import {Injectable} from '@angular/core';
import axios from "axios";
import {AuthService} from "./auth.service";
import {AgencyCountyCityList, AgencyORIList, CountyCityList, DDL, LabInfo, StateList} from "../NIBINInterface";
import {MatSnackBar} from "@angular/material/snack-bar";
import Swal from "sweetalert2";


@Injectable()
export class DropdownService {
  constructor(private authService:AuthService, private matSnackBar: MatSnackBar) {}

  public async getLabInfo(lab: string, SharedEditToken: string | null = null) : Promise<LabInfo> {
    try{
      let result = await axios.get('/NIBIN/Assets/getLabInfo?lab='+lab,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Lab Info",
        timerProgressBar:true,
        timer:3000
      })

      return <LabInfo>{}
    }
  }
  public async getLabsList() : Promise<LabInfo[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getLabs',{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Labs",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }
  }
  public async getDDL(type:string, SharedEditToken: string | null | undefined = null) : Promise<DDL[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getDropdowns?ddlType='+type,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Dropdowns",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async getAllAgency(SharedEditToken: string | null = null) : Promise<AgencyORIList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getAllAgency',{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load (ALL) Agency List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async getCountyForState(state:string, SharedEditToken: string | null = null) : Promise<CountyCityList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getCountyForState?state='+state,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load County List",
        timerProgressBar:true,
        timer:3000
      })
      return [];
    }
  }
  public async getCityForCountyAndState(county:string, state:string, SharedEditToken: string | null = null) : Promise<CountyCityList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getCityForCountyAndState?state='+state+'&county='+county,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load City List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async getAgencyForCountyAndState(county:string, state:string, SharedEditToken: string | null = null) : Promise<AgencyORIList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getAgencyForCountyAndState?state='+state+'&county='+county,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Agency List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }
  }

//------
  public async getAgencyForState(state:string | null, SharedEditToken: string | null = null) : Promise<AgencyORIList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getAgencyForState?state='+state,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Agency List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }
  }
  public async getCountyForAgencyAndState(state:string | null, agency:string | null, SharedEditToken: string | null = null) : Promise<CountyCityList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getCountyForAgencyAndState?state='+state+'&agency='+agency,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load County List",
        timerProgressBar:true,
        timer:3000
      })
      return [];
    }
  }
  public async getCityForAgencyAndCountyAndState(county:string | null, state:string | null, agency:string | null, SharedEditToken: string | null = null) : Promise<CountyCityList[]>{
    try{
      let result = await axios.get('/NIBIN/Assets/getCityForAgencyAndCountyAndState?state='+state+'&county='+county+'&agency='+agency,{ headers:{authToken:localStorage.getItem('id_token') != null? this.authService.getUser().apikey : localStorage.getItem('SharedToken') != null? localStorage.getItem('SharedToken'): ''}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load City List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }

  //-----


  public async getNJPOPAgencyForCountyAndState(county:string, state:string) : Promise<AgencyORIList[]>{
    try{
      let result = await axios.get('/NIBIN/NJPOP/getNJPOPAgencyForCountyAndState?state='+state+'&county='+county,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load Agency List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }
  }
  public async getNJPOPCityForCountyAndState(county:string, state:string) : Promise<CountyCityList[]>{
    try{
      let result = await axios.get('/NIBIN/NJPOP/getNJPOPCityForCountyAndState?state='+state+'&county='+county,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load City List",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async getNJPOPCounty(state:string) : Promise<CountyCityList[]>{
    try{
      let result = await axios.get('/NIBIN/NJPOP/getNJPOPCounty?state='+state,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Load NJPOP County List",
        timerProgressBar:true,
        timer:3000
      })
      return [];
    }
  }



  public async addCountyForState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/addCountyForState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Add County",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async updateCountyForState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/updateCountyForState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Update County",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async deleteCountyForState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/deleteCountyForState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Delete County",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async addCityForCountyState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/addCityForCountyState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Add City",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async updateCityForCountyState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/updateCityForCountyState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Update City",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async deleteCityForCountyState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/deleteCityForCountyState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Delete City",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async addAgencyForCountyState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/addAgencyForCountyState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Add Agency",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async updateAgencyForCountyState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/updateAgencyForCountyState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Update Agency",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public async deleteAgencyForCountyState(req:AgencyCountyCityList) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/Assets/deleteAgencyForCountyState',req,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Delete Agency",
        timerProgressBar:true,
        timer:3000
      })

      return [];
    }

  }
  public getHoursArray() : string[]{
    let r:string[] = []
    for(var i=0; i<24;i++){
      for(var j=0; j<60;j++){
        r.push(i.toString().padStart(2,'0')+":"+j.toString().padStart(2,'0'))
      }
    }
    return r
  }
  public async getStates() : Promise<StateList[]> {
    return [
      { name: 'ALABAMA', abbreviation: 'AL'},
      { name: 'ALASKA', abbreviation: 'AK'},
      { name: 'AMERICAN SAMOA', abbreviation: 'AS'},
      { name: 'ARIZONA', abbreviation: 'AZ'},
      { name: 'ARKANSAS', abbreviation: 'AR'},
      { name: 'CALIFORNIA', abbreviation: 'CA'},
      { name: 'COLORADO', abbreviation: 'CO'},
      { name: 'CONNECTICUT', abbreviation: 'CT'},
      { name: 'DELAWARE', abbreviation: 'DE'},
      { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
      { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM'},
      { name: 'FLORIDA', abbreviation: 'FL'},
      { name: 'GEORGIA', abbreviation: 'GA'},
      { name: 'GUAM', abbreviation: 'GU'},
      { name: 'HAWAII', abbreviation: 'HI'},
      { name: 'IDAHO', abbreviation: 'ID'},
      { name: 'ILLINOIS', abbreviation: 'IL'},
      { name: 'INDIANA', abbreviation: 'IN'},
      { name: 'IOWA', abbreviation: 'IA'},
      { name: 'KANSAS', abbreviation: 'KS'},
      { name: 'KENTUCKY', abbreviation: 'KY'},
      { name: 'LOUISIANA', abbreviation: 'LA'},
      { name: 'MAINE', abbreviation: 'ME'},
      { name: 'MARSHALL ISLANDS', abbreviation: 'MH'},
      { name: 'MARYLAND', abbreviation: 'MD'},
      { name: 'MASSACHUSETTS', abbreviation: 'MA'},
      { name: 'MICHIGAN', abbreviation: 'MI'},
      { name: 'MINNESOTA', abbreviation: 'MN'},
      { name: 'MISSISSIPPI', abbreviation: 'MS'},
      { name: 'MISSOURI', abbreviation: 'MO'},
      { name: 'MONTANA', abbreviation: 'MT'},
      { name: 'NEBRASKA', abbreviation: 'NE'},
      { name: 'NEVADA', abbreviation: 'NV'},
      { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
      { name: 'NEW JERSEY', abbreviation: 'NJ'},
      { name: 'NEW MEXICO', abbreviation: 'NM'},
      { name: 'NEW YORK', abbreviation: 'NY'},
      { name: 'NORTH CAROLINA', abbreviation: 'NC'},
      { name: 'NORTH DAKOTA', abbreviation: 'ND'},
      { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP'},
      { name: 'OHIO', abbreviation: 'OH'},
      { name: 'OKLAHOMA', abbreviation: 'OK'},
      { name: 'OREGON', abbreviation: 'OR'},
      { name: 'PALAU', abbreviation: 'PW'},
      { name: 'PENNSYLVANIA', abbreviation: 'PA'},
      { name: 'PUERTO RICO', abbreviation: 'PR'},
      { name: 'RHODE ISLAND', abbreviation: 'RI'},
      { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
      { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
      { name: 'TENNESSEE', abbreviation: 'TN'},
      { name: 'TEXAS', abbreviation: 'TX'},
      { name: 'UTAH', abbreviation: 'UT'},
      { name: 'VERMONT', abbreviation: 'VT'},
      { name: 'VIRGIN ISLANDS', abbreviation: 'VI'},
      { name: 'VIRGINIA', abbreviation: 'VA'},
      { name: 'WASHINGTON', abbreviation: 'WA'},
      { name: 'WEST VIRGINIA', abbreviation: 'WV'},
      { name: 'WISCONSIN', abbreviation: 'WI'},
      { name: 'WYOMING', abbreviation: 'WY' }
    ]
  }


}
